import React, { useReducer } from 'react';
import { ToastContainer } from 'react-toastify';

import {
  AppStateContext,
  AppDispatchContext,
  initialState,
  reducer,
} from '../../contexts/AppContext';
import AllRoutes from '../router';

import 'react-toastify/dist/ReactToastify.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import './App.css';

const App = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <div className="App" id="scrool">
      <AppDispatchContext.Provider value={{ dispatch }}>
        <AppStateContext.Provider value={{ state }}>
          <AllRoutes />
        </AppStateContext.Provider>
      </AppDispatchContext.Provider>
      <ToastContainer />
    </div>
  );
};

export default App;
